import React from 'react';
export function PackImage() {
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-16 px-4 bg-brand-green text-center overflow-hidden" data-id="element-92">
      <div className="max-w-5xl mx-auto" data-id="element-93">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-cream mb-6" data-id="element-94">
          Todo este contenido está incluido hoy dentro del mismo pack.
        </h2>
        <p className="text-lg text-brand-cream/80 mb-12 max-w-2xl mx-auto" data-id="element-95">
          Si compraras cada uno de estos materiales por separado, el valor sería
          mucho mayor. Pero hoy podés acceder a todo el pack completo por un
          precio especial.
        </p>

        <div className="relative max-w-4xl mx-auto cursor-pointer group" onClick={scrollToOffer} data-id="element-96">
          {/* Background glow */}
          <div className="absolute inset-0 bg-brand-gold/15 blur-3xl rounded-full transform group-hover:scale-105 transition-transform duration-700" data-id="element-97"></div>

          {/* Pack layout */}
          <div className="relative z-10 flex flex-col items-center gap-8" data-id="element-98">
            {/* Main Book - Hero position */}
            <div className="relative" data-id="element-99">
              <div className="absolute -inset-4 bg-brand-gold/10 blur-2xl rounded-full" data-id="element-100"></div>
              <img src="https://cdn.magicpatterns.com/uploads/npdBXfmVxUwmsE3EyXMgFs/0_cover_1.png" alt="Libro Principal - Equilibrio Hormonal Natural" className="relative w-56 md:w-72 drop-shadow-2xl transform group-hover:scale-105 transition-transform duration-500" data-id="element-101" />
              <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-brand-gold text-brand-green text-xs md:text-sm font-bold px-4 py-1.5 rounded-full shadow-lg whitespace-nowrap" data-id="element-102">
                GUÍA PRINCIPAL
              </div>
            </div>

            {/* Divider */}
            <div className="flex items-center gap-3 w-full max-w-md" data-id="element-103">
              <div className="flex-1 h-px bg-brand-gold/30" data-id="element-104"></div>
              <span className="text-brand-gold font-bold text-sm tracking-widest uppercase" data-id="element-105">
                + 4 Bonos
              </span>
              <div className="flex-1 h-px bg-brand-gold/30" data-id="element-106"></div>
            </div>

            {/* 4 Bonuses in a row */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 w-full" data-id="element-107">
              <div className="flex flex-col items-center gap-2" data-id="element-108">
                <div className="bg-white/5 rounded-2xl p-3 backdrop-blur-sm border border-white/10 group-hover:border-brand-gold/30 transition-colors duration-500" data-id="element-109">
                  <img src="https://cdn.magicpatterns.com/uploads/n11BmXugWi9UoGeWhDNYsi/bono_1.png" alt="Bono 1 - Plan Alimenticio" className="w-full h-auto drop-shadow-xl" data-id="element-110" />
                </div>
                <span className="text-brand-gold/80 text-xs font-semibold" data-id="element-111">
                  BONO 1
                </span>
              </div>

              <div className="flex flex-col items-center gap-2" data-id="element-112">
                <div className="bg-white/5 rounded-2xl p-3 backdrop-blur-sm border border-white/10 group-hover:border-brand-gold/30 transition-colors duration-500" data-id="element-113">
                  <img src="https://cdn.magicpatterns.com/uploads/xbx6BpgaHuXCbMsSy4scb2/bono_2.png" alt="Bono 2 - Infusiones y Tés" className="w-full h-auto drop-shadow-xl" data-id="element-114" />
                </div>
                <span className="text-brand-gold/80 text-xs font-semibold" data-id="element-115">
                  BONO 2
                </span>
              </div>

              <div className="flex flex-col items-center gap-2" data-id="element-116">
                <div className="bg-white/5 rounded-2xl p-3 backdrop-blur-sm border border-white/10 group-hover:border-brand-gold/30 transition-colors duration-500" data-id="element-117">
                  <img src="https://cdn.magicpatterns.com/uploads/mbhGSPcrQKboFzabf7seou/bono_3.png" alt="Bono 3 - Plan Detox" className="w-full h-auto drop-shadow-xl" data-id="element-118" />
                </div>
                <span className="text-brand-gold/80 text-xs font-semibold" data-id="element-119">
                  BONO 3
                </span>
              </div>

              <div className="flex flex-col items-center gap-2" data-id="element-120">
                <div className="bg-white/5 rounded-2xl p-3 backdrop-blur-sm border border-white/10 group-hover:border-brand-gold/30 transition-colors duration-500" data-id="element-121">
                  <img src="https://cdn.magicpatterns.com/uploads/wfpWzGZhe1VBq9VJK3Mxzr/bono_4.png" alt="Bono 4 - Suplementos" className="w-full h-auto drop-shadow-xl" data-id="element-122" />
                </div>
                <span className="text-brand-gold/80 text-xs font-semibold" data-id="element-123">
                  BONO 4
                </span>
              </div>
            </div>

            {/* Value badge */}
            <div className="bg-brand-gold/20 border border-brand-gold/40 rounded-2xl px-6 py-3 mt-2" data-id="element-124">
              <p className="text-brand-cream font-bold text-lg md:text-xl" data-id="element-125">
                5 productos en 1 solo pack
              </p>
              <p className="text-brand-cream/70 text-sm" data-id="element-126">
                Descarga inmediata · Acceso desde cualquier dispositivo
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}